export default "__VITE_ASSET__DRoYr0FI__"